import { DateTime, Duration } from 'luxon'
import { pad } from './strings'

const daysAgoFormatter = (date: Date) => {
  if (!date) {
    return `Invalid Date: ${date}`
  }
  const now = DateTime.local().setZone('UTC+7').toMillis()
  const endOfDate = DateTime.fromJSDate(date).setZone('UTC+7').endOf('days').toMillis()
  const days = Math.ceil(Duration.fromMillis(now - endOfDate).as('days'))
  console.log(now, endOfDate, days)
  if (days <= 0) {
    return 'today'
  } else if (days <= 1) {
    return 'yesterday'
  } else {
    return `${days} days ago`
  }
}

export const formatters = {
  number: (value: any, event: any): number => +value,
  decimal: (value: any, event: any): string => (+value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
  paddedIndex: (value: number, event: any): string => pad(value + 1, 2, '0') + '.',
  yyyyMMdd: (value: Date, event: any): string => DateTime.fromJSDate(value).toFormat('yyyy-MM-dd'),
  ddMMMMyyyy: (value: Date, event: any): string => DateTime.fromJSDate(value).toFormat('dd MMMM yyyy'),
  relativeDateTime: (value: Date, event: any): string => daysAgoFormatter(value),
}
